import './DataTable.scss';

import { array, arrayOf, func, object, shape, string } from 'prop-types';
import React from 'react';
import { Table } from 'react-bootstrap';

import SitecoreContextFactoryService from '@services/sitecoreContextFactoryService';
import { Link, Text } from '@sitecore-jss/sitecore-jss-react';
import { HK_SITE_NAME } from '@utils/constant';
import Global from '@utils/global';

import { convertDDMMYYYYStringToDate } from '../../utils';

const DataTable = ({ layoutData, columns, data }) => {
  const storeList = JSON.parse(window.localStorage.getItem('storeList') || '');
  const currentSiteName = SitecoreContextFactoryService.getValueContextItem('site')?.name;
  const currentLanguage = SitecoreContextFactoryService.getValueContextItem('language');

  return (
    <Table responsive className='data-table'>
      <thead className='data-table__head'>
        <tr className='data-table__row'>
          {columns.map((column) => (
            <th
              key={column.key}
              className={`data-table__data ${storeList.length === 1 && column.key.toLowerCase() === 'storename' ? 'data-table__hidden' : ''}`}
            >
              {column.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className='data-table__body'>
        {data?.map((item, index) => (
          <tr key={index} className='data-table__row'>
            {columns.map((column) => {
              const isSubmissionDate = column.key.toLowerCase() === 'submissiondate';
              let submissionDateValue = Global.customDate(item?.[`${column.key}`], false);
              // Handle check date & format date
              if (isSubmissionDate && currentLanguage === 'zh-HK' && currentSiteName === HK_SITE_NAME) {
                const dateConverted = convertDDMMYYYYStringToDate(item?.[`${column.key}`]);

                submissionDateValue = dateConverted
                  ? Global.customDate(dateConverted, false)
                  : Global.customDate(new Date(Date(item?.[`${column.key}`])), false);
              }
              const valueItem = isSubmissionDate ? submissionDateValue : item?.[`${column.key}`];

              return (
                <td
                  key={column.key}
                  className={`data-table__data ${storeList.length === 1 && column.key.toLowerCase() === 'storename' ? 'data-table__hidden' : ''}`}
                >
                  <Link
                    className='data-table__data__link'
                    field={{ href: `${layoutData?.['Appointment Detail Page']?.value?.href}?appointment_id=${item.Id}` }}
                  >
                    {column.render ? column.render(item) : <Text field={{ value: valueItem }} />}
                  </Link>
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

DataTable.propTypes = {
  columns: arrayOf(
    shape({
      key: string,
      label: string,
      render: func
    })
  ),
  data: array,
  layoutData: object
};

export default DataTable;
